import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Clock, MapPin, UserCog, Image as ImageIcon, ChevronRight, User, Phone } from 'lucide-react';

const STATUS_COLORS = {
  open: 'bg-blue-100 text-blue-700',
  accepted: 'bg-yellow-100 text-yellow-700',
  in_progress: 'bg-purple-100 text-purple-700',
  waiting_parts: 'bg-orange-100 text-orange-700',
  monitoring: 'bg-yellow-100 text-yellow-800',
  resolved: 'bg-green-100 text-green-700',
  closed: 'bg-slate-100 text-slate-700',
  rejected: 'bg-red-100 text-red-700',
  transformed: 'bg-cyan-100 text-cyan-700'
};

const STATUS_LABELS = {
  open: 'Deschis', accepted: 'Acceptat', in_progress: 'In Lucru',
  waiting_parts: 'Piese', monitoring: 'Monitorizare', resolved: 'Rezolvat', closed: 'Inchis',
  rejected: 'Respins', transformed: 'Transformat'
};

const PRIORITY_COLORS = {
  critical: 'bg-red-500 text-white', urgent: 'bg-orange-500 text-white',
  high: 'bg-amber-500 text-white', medium: 'bg-yellow-500 text-slate-900',
  low: 'bg-green-500 text-white'
};

const PRIORITY_LABELS = {
  critical: 'Critic', urgent: 'Urgent', high: 'Ridicat', medium: 'Mediu', low: 'Scazut'
};

export default function MobileTicketCard({ ticket, onClick }) {
  const priority = ticket.priority_assigned || ticket.priority_requested;
  return (
    <div
      className="bg-white rounded-xl border border-slate-200 p-3.5 active:bg-slate-50 transition-colors"
      onClick={onClick}
      data-testid={`mobile-ticket-${ticket.id}`}
    >
      <div className="flex items-start justify-between gap-2 mb-1.5">
        <h3 className="text-sm font-semibold text-slate-900 line-clamp-1 flex-1">{ticket.title}</h3>
        <ChevronRight className="w-4 h-4 text-slate-300 shrink-0 mt-0.5" />
      </div>
      {ticket.description && (
        <p className="text-xs text-slate-500 line-clamp-1 mb-2">{ticket.description}</p>
      )}

      {/* Badges */}
      <div className="flex items-center gap-1.5 flex-wrap mb-2">
        <Badge className={`${STATUS_COLORS[ticket.status]} text-[10px] px-1.5 py-0`}>
          {STATUS_LABELS[ticket.status] || ticket.status}
        </Badge>
        {ticket.status === 'waiting_parts' && ticket.parts_eta_days && (
          <Badge className="bg-orange-50 text-orange-700 border border-orange-200 text-[10px] px-1.5 py-0" data-testid={`mobile-eta-${ticket.id}`}>
            ETA {ticket.parts_eta_days}z
          </Badge>
        )}
        <Badge className={`${PRIORITY_COLORS[priority]} text-[10px] px-1.5 py-0`}>
          {PRIORITY_LABELS[priority] || priority}
        </Badge>
        {ticket.images?.length > 0 && (
          <span className="text-[10px] text-slate-400 flex items-center gap-0.5">
            <ImageIcon className="w-3 h-3" />{ticket.images.length}
          </span>
        )}
      </div>

      {/* Reporter info */}
      {(ticket.reporter_name || ticket.reporter_phone) && (
        <div className="flex items-center gap-3 text-[11px] text-slate-600 mb-2">
          {ticket.reporter_name && (
            <span className="flex items-center gap-1 font-medium">
              <User className="w-3 h-3 text-blue-500 shrink-0" />{ticket.reporter_name}
            </span>
          )}
          {ticket.reporter_phone && (
            <span className="flex items-center gap-1">
              <Phone className="w-3 h-3 text-green-500 shrink-0" />{ticket.reporter_phone}
            </span>
          )}
        </div>
      )}

      {/* Footer */}
      <div className="flex items-center gap-3 pt-2 border-t border-slate-100 text-[11px] text-slate-500">
        <span className="flex items-center gap-1 truncate">
          <MapPin className="w-3 h-3 shrink-0" />{ticket.equipment_name || '-'}
        </span>
        {ticket.assigned_to_name && (
          <span className="flex items-center gap-1 truncate">
            <UserCog className="w-3 h-3 shrink-0" />{ticket.assigned_to_name}
          </span>
        )}
        <span className="ml-auto flex items-center gap-1 shrink-0">
          <Clock className="w-3 h-3" />{new Date(ticket.created_at).toLocaleDateString('ro-RO')}
        </span>
      </div>
    </div>
  );
}
